<template>
  <div>
    <b-card title="Update Pause Job" class="mb-4">
      <b-row>
        <b-col cols="12" style="margin-bottom: 15px;">
          <b-button variant="primary" @click="goBack()">
            <feather-icon size="1x" icon="ArrowLeftIcon" />Back to Admin Panel
          </b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Username">
              <b-form-input v-model="form.user.username" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Email">
              <b-form-input v-model="form.user.email" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Pause Reason">
              <v-select
                :clearable="false"
                v-model="form.pauseReason"
                :options="pauseReasonOptions"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Pause Start">
              <b-form-input v-model="updatedData.pauseTimestamp" type="datetime-local" step="1"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Pause End">
              <b-form-input v-model="updatedData.restartTimestamp" type="datetime-local" step="1"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right">
            <b-button type="submit" variant="primary">Update</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        user: {
          username: '', 
          email: ''
        },
        pauseReason: '',
      },
      updatedData: {
        pauseTimestamp: '',
        restartTimestamp: '',
      },
      pauseReasonOptions: []
    }
  },
  mounted() {
    this.getPauseJob()
    this.getPauseReason()
  },
  computed: {
    currentUser() {
      let result = {
        updater: 'system',
        userID: null
      }
      const user = this.$store.getters['auth/getActiveUser']
      if (user.props.firstName && user.props.lastName) {
        result.updater = user.props.firstName + ' ' + user.props.lastName
      }
      if (user.id) {
        result.userID = user.id
      }
      return result
    }
  },
  methods: {
    goBack() {
      window.history.back()
    },
    getPauseJob() {
      const id = this.$route.params.id
      this.$store.dispatch("pause/getPauseJobId", {id}).then((res) => {
        const props = res
        this.form = {
          ...res
        }
        const dateFields = ['pauseTimestamp','restartTimestamp']
        dateFields.forEach(field => {
          if (props && props[field]) {
            const d = new Date(props[field])
            const pad = n => n < 10 ? '0' + n : n
            const formatted = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) 
            this.$set(this.updatedData, field, formatted)
          }
        })
      }).catch((err) => {
        console.error(err);
      })
    },
    getPauseReason() {
      this.$store.dispatch("plant/getReasonList")
      .then((res) => {
        var PauseJobReason = res.filter((x) => x.reasonName == "Pause Job");
        var allreason = PauseJobReason[0].reasonList;
        var activeReason = allreason.filter((x) => x.status === "Active")
        this.pauseReasonOptions = activeReason.map((x) => x.reason)
      })
      .catch((err) => {
        console.error(err);
      })
    },
    onSubmit() {
      const dateFields = ['pauseTimestamp','restartTimestamp']
      let payload = {}
      dateFields.forEach(field => {
        if (this.updatedData && this.updatedData[field]) {
          const d = new Date(this.updatedData[field]).toISOString()
          payload[field] = d
        }
      })
      payload.pauseReason = this.form.pauseReason
      payload.updater = this.currentUser.updater
      payload.userID = this.currentUser.userID
      this.$store.dispatch("admin/updateItem", {payload: payload, id: this.$route.params.id, type: 'pause_job'})
      .then((res) => {
        this.$bvToast.toast("Update Pause Job Success", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      })
      .catch((err) => {
        console.error(err)
        this.$bvToast.toast("Update Joborder Failed", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      })
    }
  }
}
</script>